import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {KfRegistrationSearch} from '../../../shared/models/kf-registration-search.interface';

@Component({
  selector: 'app-kf-registration-filter',
  templateUrl: './kf-registration-filter.component.html',
  styleUrls: ['./kf-registration-filter.component.scss']
})
export class KfRegistrationFilterComponent implements OnInit {

  searchForm = this.formBuilder.group({
    startYear: [''],
    endYear: [''],
    keyFigures: [''],
    b2bb2c: [''],
    status: []
  });

  get startYearControl(): FormControl {
    return this.searchForm.get('startYear') as FormControl;
  }

  get endYearControl(): FormControl {
    return this.searchForm.get('endYear') as FormControl;
  }

  get keyFiguresControl(): FormControl {
    return this.searchForm.get('keyFigures') as FormControl;
  }

  get b2bb2cControl(): FormControl {
    return this.searchForm.get('b2bb2c') as FormControl;
  }

  get statusControl(): FormControl {
    return this.searchForm.get('status') as FormControl;
  }

  @Output()
  search: EventEmitter<KfRegistrationSearch> = new EventEmitter<KfRegistrationSearch>();

  allListFilter!: boolean;

  constructor(private formBuilder: FormBuilder, private readonly router: Router, private activatedRoute: ActivatedRoute) {
    this.allListFilter = this.router.url.endsWith('all');
  }

  ngOnInit(): void {
    this.setFormValuesFromQueryParams();
  }

  handleSubmit(): void {
    const dto: KfRegistrationSearch = {
      startYear: this.startYearControl.value,
      endYear: this.endYearControl.value,
      keyFigures: this.keyFiguresControl.value,
      b2bb2c: this.b2bb2cControl.value,
      status: this.statusControl.value
    };
    this.search.emit(dto);
  }

  clean(): void {
    this.search.emit({});
  }

  private setFormValuesFromQueryParams(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.startYear) {
        this.searchForm.get('startYear')?.setValue(params.startYear);
      }
      if (params.endYear) {
        this.searchForm.get('endYear')?.setValue(params.endYear);
      }
      if (params.keyFigures) {
        this.searchForm.get('keyFigures')?.setValue(params.keyFigures);
      }
      if (params.b2bb2c) {
        this.searchForm.get('b2bb2c')?.setValue(params.b2bb2c);
      }
      if (params.status) {
        this.searchForm.get('status')?.setValue(params.status);
      }
    });
  }

}
